import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import BannerImag from '../../../Assets/images/DFL/landing-page-img/engagment-static-page-img/banner_img.png';
import LineImg from '../../../Assets/images/DFL/landing-page-img/engagment-static-page-img/line_1.png';
import IconImg1 from '../../../Assets/images/DFL/landing-page-img/engagment-static-page-img/eng-icon1.png';
import IconImg2 from '../../../Assets/images/DFL/landing-page-img/engagment-static-page-img/eng-icon2.png';
import IconImg3 from '../../../Assets/images/DFL/landing-page-img/engagment-static-page-img/eng-icon3.png';
import { NavLink } from 'react-router-dom';
import LazyLoad from 'react-lazy-load';
import { isMobile, isTablet } from 'react-device-detect';

const EngagementRings = () => {
  const [screenSize, setScreenSize] = useState(getScreenSize());

  function getScreenSize() {
    const width = window.innerWidth;
    
    if (width < 768) {
      return 'mobile';
    } else if (width > 768 && width <= 1024) {
      return 'tablet';
    } else {
      return 'desktop';
    }
  }
  const handleResize = () => {
    setScreenSize(getScreenSize());
  };
  useEffect(() => {
 
    window.addEventListener('resize', handleResize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return (
    // <LazyLoad className='lazyLoad-heroBanner' height={screenSize === 'mobile'  ?750: screenSize === 'tablet' ? 420 : 620} width="100%" threshold={0.90}>
    <div className="dfl_e_engament_ring_section">
      <Container className="dfl_custome_container_staticpage">
        <Row>
          {/* <Col sm={12} md={6} lg={6}>
                        <div>
                            <Image src={BannerImag} alt="Ring Banner Image" className="img-fluid" />
                        </div>
                    </Col> */}
          <Col
            sm={12}
            md={{ span: 6, offset: 6 }}
            lg={{ span: 6, offset: 6 }}
            className="dfl_eng_box"
          >
            <Image
              src={BannerImag}
              alt="Ring Banner Image"
              className="img-fluid dfl_eng_ribg_d_none_desktop"
            />
            <div>
              <div className="eng-box2 text-center box-design">
                <div className="title-box4 text-center">
                  <h1 className="title32">Engagement Rings Toronto</h1>
                  {/* <img src={LineImg} alt="line 1" /> */}
                </div>
                <p className="both-pr">
                  The perfect proposal starts with a DFL engagement ring!
                </p>
                <p className="both-pr">
                Explore our vast selection of over 1000 styles ranging from the latest trending designs to timeless classics. Select your preferred loose diamond and let our team of experts craft the perfect engagement ring that exceeds your dreams.
                </p>
                <div className="eng-btn pt-0">
                  <ul>
                    <li>
                      {' '}
                      <NavLink to="#">
                        {' '}
                        <img src={IconImg1} alt="ring shap" />{' '}
                      </NavLink>{' '}
                    </li>
                    <li>+ </li>
                    <li>
                      {' '}
                      <NavLink to="#">
                        {' '}
                        <img src={IconImg2} alt="diamond" />{' '}
                      </NavLink>{' '}
                    </li>
                    <li>= </li>
                    <li>
                      {' '}
                      <img src={IconImg3} alt="complete ring" />{' '}
                    </li>
                  </ul>
                  <Row className="btn-wrapper text-uppercase text-center pt-4">
                    <Col xs={12} sm={12} md={6} lg={6}>
                      {' '}
                      <NavLink className="btn-engage" to="/ringsettings">
                        {' '}
                        Ring Settings{' '}
                      </NavLink>{' '}
                    </Col>
                    <Col xs={12} sm={12} md={6} lg={6}>
                      {' '}
                      <NavLink className="btn-engage" to="/diamonds">
                        {' '}
                        LOOSE DIAMONDS{' '}
                      </NavLink>{' '}
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
    // </LazyLoad>
  );
};

export default EngagementRings;
